import { addDaysLocal } from "@/lib/bookingDates";

/** Berechnet Ostersonntag (Gregorianisch). */
function easterSunday(year: number): { month: number; day: number } {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return { month, day };
}

function isoFromParts(year: number, month: number, day: number): string {
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

function easterIso(year: number): string {
  const { month, day } = easterSunday(year);
  return isoFromParts(year, month, day);
}

function holidaysForYear(year: number): Map<string, string> {
  const holidays = new Map<string, string>();
  holidays.set(isoFromParts(year, 1, 1), "Neujahr");
  holidays.set(isoFromParts(year, 5, 1), "Tag der Arbeit");
  holidays.set(isoFromParts(year, 10, 3), "Tag der Deutschen Einheit");
  holidays.set(isoFromParts(year, 12, 25), "1. Weihnachtsfeiertag");
  holidays.set(isoFromParts(year, 12, 26), "2. Weihnachtsfeiertag");

  const easter = easterIso(year);
  holidays.set(addDaysLocal(easter, -2), "Karfreitag");
  holidays.set(addDaysLocal(easter, 1), "Ostermontag");
  holidays.set(addDaysLocal(easter, 39), "Christi Himmelfahrt");
  holidays.set(addDaysLocal(easter, 50), "Pfingstmontag");

  return holidays;
}

const cache = new Map<number, Map<string, string>>();

function yearMap(year: number): Map<string, string> {
  let map = cache.get(year);
  if (!map) {
    map = holidaysForYear(year);
    cache.set(year, map);
  }
  return map;
}

/** Gibt den Namen eines bundesweiten deutschen Feiertags zurück, sonst null. */
export function getGermanPublicHoliday(isoDate: string): string | null {
  const year = Number(isoDate.slice(0, 4));
  return yearMap(year).get(isoDate) ?? yearMap(year - 1).get(isoDate) ?? yearMap(year + 1).get(isoDate) ?? null;
}
